/**
 * Calculates the fill width for a star in a rating display.
 *
 * @param rating - The rating value (0-5)
 * @param starIndex - The index of the star (0-based)
 * @returns The fill width of the star (percentage string)
 *
 * @example
 * getStarFillWidth(4.8, 4) // '80%' (5th star is 80% filled)
 * getStarFillWidth(3.0, 2) // '100%' (3rd star is completely filled)
 * getStarFillWidth(2.5, 3) // '0%' (4th star is not filled)
 */
export function getStarFillWidth(rating: number, starIndex: number): string {
  const starNumber = starIndex + 1;

  if (starNumber <= rating) {
    return '100%';
  } else if (starNumber - 1 < rating) {
    const fillPercentage = (rating - (starNumber - 1)) * 100;
    return `${fillPercentage}%`;
  }

  return '0%';
}
